import { render, staticRenderFns } from "./test-list.vue?vue&type=template&id=04699bfe&scoped=true&"
import script from "./test-list.vue?vue&type=script&lang=js&"
export * from "./test-list.vue?vue&type=script&lang=js&"
import style0 from "./test-list.vue?vue&type=style&index=0&id=04699bfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04699bfe",
  null
  
)

export default component.exports